import { postJson } from 'utils/http/postJson';

import { ApiShortUrlType } from './types/ApiShortUrlType';

type Args = {
  toType: ApiShortUrlType;
  toId?: string;
  toUrl?: string;
  extraParams?: Array<{
    name: string;
    value: string;
  }>;
};

export async function apiGetShortUrl({
  toType,
  toId,
  toUrl,
  extraParams = [],
}: Args): Promise<string> {
  const { url } = await postJson<{ url: string }>('/data/short-urls', {
    toType,
    toId,
    toUrl,
    extraParams,
    locale: CURRENT_LOCALE,
  });

  return url;
}
